export enum TicketPDFOptions {
  PDF = 'PDF',
  PDF_WITHOUT_IMAGES = 'PDF_WITHOUT_IMAGES',
  PDF_IMAGES_ONLY = 'PDF_IMAGES_ONLY',
  PDF_WITHOUT_TOTAL_AMOUNT = 'PDF_WITHOUT_TOTAL_AMOUNT',
  PDF_WITH_IMAGES_WITHOUT_TOTAL_AMOUNT = 'PDF_WITH_IMAGES_WITHOUT_TOTAL_AMOUNT',
}
